import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import AiExtractor, {SupportedModel} from "../domain/AiExtractor";

class AiExtractorService {

    readonly basePath = "/ai-extractors";

    public add(aiExtractor: AiExtractor): Promise<string> {
        return Axios.post(`${this.basePath}`, aiExtractor).then(value => value.data.id);
    }

    public update(id: string, aiExtractor: AiExtractor): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, aiExtractor);
    }

    public get(id: string): Promise<AiExtractor> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => AiExtractor.fromPOJO(value.data));
    }

    public delete(aiExtractor: AiExtractor): Promise<void> {
        return Axios.delete(`${this.basePath}/${aiExtractor.id}`);
    }

    public getList(queryOptions: QueryOptions, vulSourceId?: string): Promise<PagedResult<AiExtractor>> {
        const query = queryOptions.toQueryParams();
        const url = vulSourceId ? `${this.basePath}?${query}&vulSourceId=${vulSourceId}` : `${this.basePath}?${query}`;

        return Axios.get(url)
            .then(value => new PagedResult(
                value.data.total,
                value.data.data.map((objectJson: object) => AiExtractor.fromPOJO(objectJson))
            ));
    }

    public updateVulSources(aiExtractorId: string, vulSourceIds: string[], scope: 'system' | 'organization'): Promise<void> {
        return Axios.put(`${this.basePath}/${aiExtractorId}/vul-sources?scope=${scope}`, {vulSourceIds});
    }

    public getSupportedModels(): Promise<Record<string, { models: SupportedModel[] }>> {
        return Axios.get("/ai-extractors/supported-models")
            .then(value => value.data);
    }
}

export default AiExtractorService;
